module.exports = __webpack_public_path__ + "static/media/analyze resume.c4ee986b.png";